import React, { createContext, useState, useContext } from 'react';

// 1️⃣ Creamos el Contexto
const FormContext = createContext();

// 2️⃣ Creamos el Proveedor de Datos
export const FormProvider = ({ children }) => {
  const [idclientcreate, setIdClientCreate] = useState();
  const [formData, setFormData] = useState({
    numero_identificacion: '',
    primerapellido: '',
    segundoapellido: '',
    nombres: '',
    tipo_identificacion: '',
    pais_nacimiento: '',
    provincia_nacimiento: '',
    fecha_nacimiento: '',
    sexo: '',
    nivel_instruccion: '',
    nacionalidad: '',
    estado_civil: '',
    etnia: '',
    primerapellidoConyugue: '',
    segundoapellidoConyugue: '',
    nombresConyugue: '',
    tipo_identificacionConyugue: '',
    numero_identificacionConyugue: '',
    fecha_nacimientoConyugue: '',
    pais_nacimientoConyugue: '',
    profesionConyugue: '',
    actividad_economicaConyugue: '',
    nacionalidadConyugue: '',
    nivel_instruccionConyugue: '',
    ingresos_mensualesConyugue: '',
    correo_electronicoConyugue: '',
    numerocargas: '',

    pais_trabajo: '',

    provincia_trabajo: '',

    canton_trabajo: '',

    ciudad_trabajo: '',

    parroquia_trabajo: '',
    calleprincipal_trabajo: '',
    numerodireccion_trabajo: '',
    calletransversal_trabajo: '',
    referenciadireccion_trabajo: '',

    tipovivienda: '',
    sueldoempresa: '',

    total_activos: '',
    total_pasivos: '',
    total_egresos: '',
    total_ingresos: '',

    fecha_ingreso_empresa: '',

    pais_domicilio: '',
    provincia_domicilio: '',
    canton_domicilio: '',
    ciudad_domicilio: '',
    parroquia_domicilio: '',
    sector_barrio_domicilio: '',
    calle_principal_domicilio: '',
    numero_domicilio: '',
    calle_secundaria_domicilio: '',
    tiempo_residencia: '',
    telefono_domicilio: '',
    celular: '',
    correo_electronico: '',
    punto_referencia: '',
    codigo_postal: '',
    condicion_laboral: '',
    condicion_laboral_educacional: '',
    nombre_empresa: '',
    actividad_economica: '',
    cargo: '',
    profesion: '',
    tiempo_antiguedad: '',
    telefono_trabajo: '',
    otra_actividad_economica: '',
    pep: '',
    ingresos_fijos: '',
    ingresos_conyuge: '',
    otros_ingresos: '',
    origen_otros_ingresos: '',
    egresos_servicios: '',
    egresos_arriendo: '',
    egresos_educacion: '',
    egresos_vestimenta: '',
    egresos_prestamos: '',
    egresos_tarjetas: '',
    egresos_transporte: '',
    egresos_salud: '',
    egresos_alimentacion: '',
    otros_egresos: '',
    bienes_muebles: '',
    bienes_inmuebles: '',
    vehiculos: '',
    inversiones: '',
    caja_bancos: '',
    otros_activos: '',
    deudas_ifis: '',
    deudas_tarjetas: '',
    otros_pasivos: '',
    nombres_apellidos: '',
    parentesco: '',
    direccion_domiciliaria: '',
    telefono_convencional: '',
    telefono_celular: '',
  });

  const [formDataDenariusCreateUpdateClient, setFormDataDenariusCreateUpdateClient] = useState({
    identificacion: '',
    tipoidentificacion: '',
    nombres: '',
    primerapellido: '',
    segundoapellido: '',
    fechanacimiento: '',
    sexo: '',
    pais: '',
    nacionalidad: '',
    provincia: '',
    estadocivil: '',
    estudios: '',
    actividadeconomica: '',
    profesion: '',
    email: '',
    telefono: '',
    codigooficial: '20',
    productoinicial: 'AHO',
    usainternet: true,
    egresomensual: '',
    ingresomensual: '',
    telefonosms: '',
    numerocargas: '',
    activos: '',
    pasivos: '',

    calleprincipal: '',
    numerodireccion: '',
    provinciadireccion: '',
    ciudaddireccion: '',
    cantondireccion: '',
    parroquiadireccion: '',
    calletransversal: '',
    referenciadireccion: '',
    tipovivienda: '',

    tipoactividad: '',
    nombreempresa: '',
    actividadeconomicaempresa: '',
    cargoempresa: '',
    fechaingresoempresa: '',
    sueldoempresa: '',
    telefonotrabajo: '',

    identificacionpareja: '',
    nombrespareja: '',
    primerapellidopareja: '',
    segundoapellidopareja: '',
    fechanacimientopareja: '',
    paispareja: '',
    nacionalidadpareja: '',
    estudiospareja: '',
    ingresomensualpareja: '',
    actividadeconomicapareja: '',
    profesionpareja: '',
    emailpareja: '',
    productoinicialpareja: 'AHO',

    nombrereferencia: '',
    telefonoreferencia: '',
    direccionreferencia: '',
    parentescoreferencia: '',
    nombrereferencia2: '',
    telefonoreferencia2: '',
    direccionreferencia2: '',
    parentescoreferencia2: '',

    calleprincipaltrabajo: '',
    numerodirecciontrabajo: '',
    provinciadirecciontrabajo: '',
    ciudaddirecciontrabajo: '',
    cantondirecciontrabajo: '',
    parroquiadirecciontrabajo: '',
    calletransversaltrabajo: '',
    referenciadirecciontrabajo: '',
  });

  // Actualiza los datos sin perder lo anterior
  const updateFormData = (newData) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
    sessionStorage.setItem('formDataIncoop', JSON.stringify({ ...formData, ...newData }));
  };

  const updateIdClientCreate = (IdClient) => {
    setIdClientCreate(IdClient);
    sessionStorage.setItem('IdClientCreate', IdClient);
  };

  const deleteIdClientCreate = () => {
    setIdClientCreate('');
    sessionStorage.removeItem('IdClientCreate');
  };

  const updateFormDataenariusCreateUpdateClient = (newData) => {
    setFormDataDenariusCreateUpdateClient(newData);
  };

  const deleteFormData = () => {
    setFormData({});
    sessionStorage.removeItem('formDataIncoop');
  };

  return (
    <FormContext.Provider
      value={{
        formDataDenariusCreateUpdateClient,
        updateFormDataenariusCreateUpdateClient,
        formData,
        updateFormData,
        deleteFormData,
        updateIdClientCreate,
        deleteIdClientCreate,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

// 3️⃣ Hook personalizado para acceder al contexto
export const useFormContext = () => useContext(FormContext);
